export const CONSENT_STORAGE_KEY = 'ej_cookie_consent';
export const OPEN_PRIVACY_CHOICES_EVENT = 'ej-open-privacy-choices';

const DENIED = 'denied';
const GRANTED = 'granted';

function gtag() {
    window.dataLayer.push(arguments);
}

export function hasGlobalPrivacyControl() {
    return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
}

export function readStoredConsent() {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const parsed = JSON.parse(raw);
        if (typeof parsed?.analytics !== 'boolean' || typeof parsed?.ads !== 'boolean') {
            return null;
        }

        return {
            analytics: parsed.analytics,
            ads: parsed.ads,
            updatedAt: parsed.updatedAt ?? null,
        };
    } catch {
        return null;
    }
}

export function writeStoredConsent(choice) {
    const stored = {
        analytics: Boolean(choice.analytics),
        ads: Boolean(choice.ads),
        updatedAt: new Date().toISOString(),
    };
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(stored));
    return stored;
}

function ensureDataLayer() {
    window.dataLayer = window.dataLayer || [];
}

export function applyConsent(choice) {
    ensureDataLayer();
    const adsAllowed = Boolean(choice?.ads) && !hasGlobalPrivacyControl();
    const analyticsAllowed = Boolean(choice?.analytics);

    gtag('consent', 'update', {
        analytics_storage: analyticsAllowed ? GRANTED : DENIED,
        ad_storage: adsAllowed ? GRANTED : DENIED,
        ad_user_data: adsAllowed ? GRANTED : DENIED,
        ad_personalization: adsAllowed ? GRANTED : DENIED,
    });

    if (analyticsAllowed || adsAllowed) {
        loadGoogleTagManager();
    }
}

let gtmLoaded = false;

export function loadGoogleTagManager() {
    if (gtmLoaded || typeof document === 'undefined') {
        return;
    }

    const gtmId = 'GTM-W2VTTCGV';
    ensureDataLayer();
    window.dataLayer.push({ event: 'gtm.js', 'gtm.start': Date.now() });

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.async = true;
    document.head.appendChild(script);
    gtmLoaded = true;
}

export function openPrivacyChoices() {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(new CustomEvent(OPEN_PRIVACY_CHOICES_EVENT));
}
